import React from 'react'

import { getQueryParams } from '../../utils/helpers/url'
import FullPageMessage from '../../components/presentation/FullPageMessage'

const FullMessagePage = () => {
  const { title, description, type } = getQueryParams()

  return <FullPageMessage title={title} description={description} type={type} />
}

export default FullMessagePage
